import { ResponsePanelItemWebComponent } from './component/ResponsePanelItemWebComponent';
import { WEB_COMPONENT_RESPONSE_PANEL_ITEM } from '../../webcomponents.constants';

export { ResponsePanelItemWebComponent };

window.customElements.define(WEB_COMPONENT_RESPONSE_PANEL_ITEM, ResponsePanelItemWebComponent);
